export const isEqual = (value: string | number, compareValue: string | number) => {
    return value === compareValue;
};

export const isNotEqual = (value: string | number, compareValue: string | number) => {
    return value !== compareValue;
};
